import { PATH_ROOT } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useEmailRecipientBreadcrumbs = () => {
  const { t } = useTranslation();

  return useMemo<BreadcrumbItem[]>(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("emailRecipients.breadcrumb.directory") },
    ],
    [t],
  );
};
